// Fatching user records
export const SET_USERS: string = "SET_USERS";
export const FACTCH_USERS: string = "FACTCH_USERS";
